<template>

  <div id="uni_Map">
    <div id="mapContainer" class="mapContainer"></div>

    <div class="layout-content" v-if="selectedlayout && layouts && layouts.length > 1">
      <div class="item layout" v-for="layout in layouts" @click="toggleViewType(layout.code)">
        <img :src="'/img/map/layout_' + layout.code + '.jpg'" :alt="layout.code" class="img-fluid"
             width="300" height="300">
      </div>
    </div>
  </div>

</template>

<script setup lang="ts">

import {obtainActiveWebCountry} from "../../../composables/master_page";

interface DefaultMapOptions {
  center: Number[],
  markerPosition: Number[],
  maxZoom: Number,
  minZoom: Number,
  zoom: Number,
  events: { [k: string]: Function },
  mapContainerOptions: {}
}

import "~/assets/less/uni_map.min.css";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import {Map, Layer, Marker} from "leaflet";
import {GestureHandling} from "leaflet-gesture-handling";
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";
import {onMounted, PropType, ref} from "vue";
import {useRuntimeConfig} from "#app";

const props = defineProps(['center', 'zoom', 'maxZoom', 'minZoom', 'mapContainerOptions', 'events', 'markerPosition']);

const layouts = [{
  code: 'satelite',
  url: `https://api.mapbox.com/styles/v1/mapbox/satellite-v9/tiles/256/{z}/{x}/{y}?dev=false&access_token=${useRuntimeConfig().public.MAPBOX_API_KEY}`
}, {
  code: 'classic',
  url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png'
}];


const defaultMapOptions = {
  sk: {
    maxZoom: 19,
    minZoom: 7,
    center: [48.673753, 19.696058]
  }, cs: {
    maxZoom: 19,
    minZoom: 7,
    center: [49.803763, 15.474913]
  }, pl: {
    maxZoom: 19,
    minZoom: 7,
    center: [51.9189046, 19.1343786]
  }, hu: {
    maxZoom: 19,
    minZoom: 7,
    center: [47.1611615, 19.5057541]
  }
};

const activeCountry = obtainActiveWebCountry();
const selectedlayout = ref(layouts.find(c => c.code === 'classic').url);
const map = ref<Map | null>(null);
const mapLayer = ref<Layer | null>(null);
const mapMarker = ref<Marker | null>(null);
const zoomLevel = props.zoom ? props.zoom : 8;
const mapCenter = props.center ? props.center : defaultMapOptions[activeCountry.code].center;
const markerIcon = new L.Icon({
  iconUrl: '/img/map-marker.png',
  iconSize: [27, 42], // size of the icon
})


onMounted(() => {
  initMap(props as DefaultMapOptions);
})

const initMap = (options: DefaultMapOptions) => {

  L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);


  map.value = L.map('mapContainer', options.mapContainerOptions ? options.mapContainerOptions : {});

  if (options.events) {
    Object.keys(options.events).forEach(k => {
      map.value.on(k, options.events[k]);
    })
  }

  map.value.setView(mapCenter, zoomLevel);
  mapLayer.value = L.tileLayer(selectedlayout.value,
      {
        maxZoom: options.maxZoom ? options.maxZoom : defaultMapOptions[activeCountry.code].maxZoom,
        minZoom: options.minZoom ? options.minZoom : defaultMapOptions[activeCountry.code].minZoom,
      }
  ).addTo(map.value);

  if (options.markerPosition) {
    mapMarker.value = L.marker(options.markerPosition, {icon: markerIcon}).addTo(map.value);
  } else {
    mapMarker.value = L.marker([0, 0], {icon: markerIcon}).addTo(map.value);
  }

}


const toggleViewType = (layoutCode) => {
  selectedlayout.value = layouts.find(l => l.code === layoutCode).url;
  mapLayer.value = L.tileLayer(selectedlayout.value,).addTo(map.value);
}

defineExpose({
  map, mapMarker
})

</script>

